export default "__VITE_ASSET__0nAJBzbQ__"